module.exports = __webpack_public_path__ + "static/media/slide3-files.792f3470.png";